export const it = {
  extraTitle: "Altre ragioni per scegliere Sweet Trading",
  extraText: "Siamo un team appassionato di tecnologia e mercati finanziari. Lavoriamo ogni giorno per fornirti strumenti affidabili e di alta qualità, sempre un passo avanti al mercato.",
  heroTitle: "UNA NUOVA GENERAZIONE DI TRADING",
  heroSubtitle: "il 98% dei trader fallisce, ma non oggi, non più. Siamo finalmente qui per cambiare questa statistica per sempre. Prendi parte alla rivoluzione, adesso.",
  buttonText: "Scopri Candy Bot",
  buttonLink: "#promo-section",
  whyTitle: "Perché scegliere Candy Bot?",
  whyText: "Automazione, intelligenza, velocità. Tutto con un design che ti fa venire voglia di fare trading ogni giorno.",
  disclaimer: "Tutte le informazioni fornite su questo sito sono esclusivamente a scopo educativo riguardante il trading sui mercati finanziari e non costituiscono in alcun modo una raccomandazione specifica di investimento, raccomandazione commerciale, analisi di opportunità di investimento o altra raccomandazione generale riguardo al trading di strumenti finanziari. Le informazioni su questo sito non sono rivolte ai residenti di alcun paese o giurisdizione in cui tale distribuzione o uso sarebbe contrario alle leggi o regolamenti locali.",

 clockSection: {
  title1: "Ogni Tick",
  title2: "Conta",
  line1: "Ogni secondo, 24 ore al giorno, 5 giorni su 7 il nostro bot analizza i mercati",
  line2: " per individuare le migliori opportunità di trading."
},


  processSection: {
    title: "Il Processo in 3 Passi",
    subtitle: "Dalla registrazione al prelievo del profitti – tutto semplice e trasparente",
    steps: [
      {
        number: "1",
        title: "Acquista il tuo piano",
        description: "Scegli il bot che meglio si adatta alle tue esigenze e completa l'acquisto in pochi semplici click.",
        timeLabel: "2 minuti"
      },
      {
        number: "2",
        title: "Trading Attivo",
        description: "Avvia il tuo bot seguendo le istruzioni del piano selezionato. Il nostro sistema ti guiderà passo dopo passo.",
        timeLabel: "Tempo variabile"
      },
      {
        number: "3",
        title: "Preleva i Tuoi Profitti",
        description: "Ricevi i tuoi guadagni direttamente sul tuo conto bancario o wallet preferito entro 24-48 ore.",
        timeLabel: "24-48 ore"
      }
    ],
    ctaText: "Prova Candy Bot Gratis"
  },

  whySection: {
    title: "Dolce e Potente",
    description: "C'è qualcosa di più dolce dei soldi? Sì! Soldi facili. Purtroppo, i soldi facili non esistono, ma Candy Bot è pronto ad addolcire la pillola e fare il lavoro duro per te.",
    features: [
      {
        title: "Potenza AI",
        highlight: "Artefici di cambiamenti inevitabili",
        description: "Candy Bot utilizza l'IA più avanzata con reti neurali proprietarie per analizzare i mercati globali in tempo reale. Il nostro sistema combina deep learning, riconoscimento di pattern e analisi predittiva per adattarsi dinamicamente a condizioni di mercato volatili.",
        image: "/ai.jpg",
        icon: "FaRobot"
      },
      {
        title: "Risultati Straordinari",
        highlight: "The one, the first, the best",
        description: "Creato per dare vita alle migliori opportunità. Ottimizzato per ridurre al minimo gli errori e massimizzare i profitti. I nostri algoritmi adattivi perfezionano continuamente le strategie di trading e implementano protocolli di gestione del rischio robusti.",
        image: "/performance.jpg",
        icon: "FaChartLine"
      },
      {
        title: "Market-Optimized",
        highlight:"il Tempismo è tutto",
        description: " Forex, stock o crypto, ogni modello presenta una specializzazione specifica per il contesto di mercato in cui opera, così da cogliere sempre l'attimo vincente.",
        image: "/forex.jpg",
        icon: "FaBolt"
      }
    ]
  },

  tryBot: "Prova Candy Bot Gratis",
  sweetPower: "Dolce e Potente",
  sweetText: "C'è qualcosa di più dolce dei soldi? Sì! Soldi facili. Purtroppo, i soldi facili non esistono, ma Candy Bot è pronto ad addolcire la pillola e fare il lavoro duro per te.",
  aiTitle: "Potenza AI",
  aiSubtitle: "Intelligenza Artificiale",
  aiText: "Candy Bot utilizza l'IA più avanzata per analizzare i mercati in tempo reale. Grazie a un motore neurale potenziato, combina riconoscimento di pattern, clustering e strategie predittive per adattarsi dinamicamente a ogni condizione di mercato.",
  learnMore: "Scopri di più →",
  performanceTitle: "Performance Costante",
  performanceSubtitle: "Performance Eccezionali",
  performanceText: "Ottimizzato per ridurre gli errori e massimizzare i profitti. Il nostro sistema ottimizza costantemente le strategie per massimizzare i rendimenti minimizzando i rischi.",
  forexTitle: "Ottimizzato Forex",
  forexSubtitle: "Velocità Suprema",
  forexText: "Agisce in millisecondi quando vengono rilevati pattern chiave. Reagisce ai cambiamenti di mercato in millisecondi, assicurando sempre il tempismo perfetto per ogni trade.",

  numbersTitle: "I Numeri Parlano",
  numbersSubtitle: "La nostra community cresce ogni giorno. Unisciti a migliaia di trader soddisfatti.",
  stats: [
    { value: "26+", label: "Mesi Redditizi", desc: "Crescita costante dal lancio" },
    { value: "7.000+", label: "Membri della Community", desc: "Unisciti alla nostra famiglia" },
    { value: "19.529", label: "Trade di Successo", desc: "Eseguiti con profitto" },
    { value: "89,7%", label: "Tasso di Successo", desc: "Performance complessiva" }
  ],

  offerTitle: "Offerta Speciale",
  offerSubtitle: "Candy Bot Pro",
  offerText: "La soluzione smart per il trading che lavora per te",

  plans: [
    {
      name: "Candy Bot",
      desc: "Per iniziare il tuo percorso",
      price: "0€",
      originalPrice: "169€",
      period: "per le prime 24 ore",
      features: ["Accesso completo al bot", "Supporto 24/7", "Dashboard avanzata", "Analisi predittiva AI"],
      cta: "Inizia la Prova Gratuita",
      isNew: true
    }
  ],

  promo: {
    badge: "Offerta Speciale",
    title: "Candy Bot",
    subtitle: "Per celebrare il lancio del nostro nuovo bot e segnare con orgoglio questa tappa, abbiamo deciso di offrirlo a un prezzo imbattibile, <strong>disponibile solo per un periodo limitato</strong>.",
    cardTitle: "Candy Bot Standard",
    cardSubtitle: "Inizia oggi il tuo percorso",
    newBadge: "NUOVO",
    oldPrice: "99€",
    newPrice: "0€",
    limitedNote: "Offerta a tempo limitato",
    features: [
      "Accesso completo al bot",
      "Supporto 24/7",
      "Dashboard avanzata",
      "Analisi AI"
    ],
    button: "Scopri Candy Bot",
    promoTitle: "Promozione a Tempo Limitato",
    promoText: "Registrati <strong>ora</strong> e ottieni accesso completo — senza pagamenti, senza impegno.",
    endsSoon: "L'offerta scade presto!",
    benefits: [
      "✅ Zero costi",
      "✅ Cancellazione in qualsiasi momento",
      "✅ Attivazione immediata",
      "✅ Aggiornamenti gratuiti"
    ],
    guarantee: "🔒 Garanzia soddisfatti o rimborsati di 14 giorni"
  },

  promoTitle: "Promozione Limitata",
  promoText: "Per celebrare il lancio di Candy Bot Pro, offriamo accesso gratuito completo al nuovo Bot per 24 ore a tutti i nuovi utenti iscritti entro il 6 maggio.",
  promoItems: ["✅ Nessun costo, nessun investimento", "✅ Nessun impegno", "✅ Supporto dedicato", "✅ Aggiornamenti gratuiti"],
  promoGuarantee: "Garanzia soddisfatti o rimborsati di 14 giorni",

  compareTitle: "Confronta i Piani",
  compareSubtitle: "Dalle soluzioni tradizionali all'IA avanzata, scegli la versione perfetta per le tue esigenze",

  compareSection: {
    planTitle: "Candy Bot Standard",
    planSubtitle: "Tutto ciò che ti serve per iniziare",
    priceFree: "0€",
    priceOld: "99€",
    offerNote: "Offerta a tempo limitato",
    features: [
      
      "7 coppie Forex",
      "Supporto 24/7",
      "Guida passo-passo",
      "70% profit share",
      "Investimento minimo 100$"
    ],
    button: "Ottieni ora gratuitamente",
    popupTitle: "Stai per ottenere Candy Bot Standard",
    popupSubtitle: "Inserisci i tuoi dati per richiedere l'offerta gratuita",
    form: {
      name: "Nome completo",
      email: "Email",
      password: "Password",
      confirmPassword: "Conferma password",
      submit: "Registrati & Ottieni Accesso"
    },
    disclaimer: "Cliccando su \"Registrati\" accetti i nostri",
    terms: "Termini di servizio",
    privacy: "Norme sulla privacy"
  },
comingSoonSection: {
  badge: "PROSSIMAMENTE",
  title: "Candy Bot Pro",
  subtitle: "Trading AI di nuova generazione",
  priceLabel: "Disponibile a breve",
  priceDescription: "Disponibile a breve",
  features: [
    "Modello AI per Stock/Forex/Crypto",
    "3 mercati differenti",
    "Supporto prioritario 24/7",
    "Guida passo-passo all'installazione",
    "70% profit share",
    "Investimento minimo 500$"
  ],
  buttonText: "Disponibile a breve"
},
   faq: {
    title: "Domande Frequenti",
    description: "Tutte le risposte alle domande più comuni sul nostro servizio",
    items: [
      {
        question: "Come posso iniziare a usare Candy Bot?",
        answer: "Clicca semplicemente su 'Inizia la Prova Gratuita' e segui il processo di registrazione."
      },
      {
        question: "E se non conosco nulla di trading?",
        answer: "Non preoccuparti: Candy Bot è stato progettato appositamente per chi desidera avvicinarsi al mondo del trading senza affrontarne i tradizionali rischi, oppure semplicemente per chi cerca una fonte di reddito mensile aggiuntiva in modo semplice e sicuro."
      },
      {
        question: "Qual è il rendimento medio mensile?",
        answer: "I rendimenti variano in base alle condizioni di mercato e al piano scelto, ma con il capitale adeguato e il bot giusto è possibile ottenere un reddito mensile completo."
      },
      {
        question: "A chi sono adatti i Bot?",
        answer: "Perfetto per chiunque abbia più di 18 anni e desideri fare trading senza rischi o aumentare facilmente il proprio reddito mensile."
      },
      {
        question: "Posso usare più bot contemporaneamente?",
        answer: "Sì! Puoi attivare più bot, ma ciascuno deve operare su account separati per evitare conflitti."
 },
      {
        question: "Cos'è il Forex?",
        answer: "Il Forex è il mercato dove si scambiano valute come euro e dollaro. È il più grande al mondo, aperto 24 ore su 24, e permette di guadagnare sfruttando le variazioni dei tassi di cambio."
      }
    ]
  },
  
  comparisonPlans: [
    {
      name: "Bot Gen I",
      desc: "Trading tradizionale",
      price: "89€",
      originalPrice: "99€",
      discount: "-10%",
      features: ["Meno trade", "Analisi di mercato base", "Supporto via email", "3 coppie Forex"],
      cta: "Acquista Ora",
      type: "Una tantum (10% sconto)"
    },
    {
      name: "Candy Bot Pro",
      desc: "IA di seconda generazione",
      price: "0€",
      originalPrice: "169€",
      type: "Gratis per tempo limitato",
      features: ["Trade illimitati", "Analisi predittiva AI", "12 coppie Forex", "Supporto prioritario 24/7", "Dashboard avanzata"],
      cta: "Ottieni Gratis",
      isOffer: true
    },
    {
      name: "Enterprise",
      desc: "Soluzione personalizzata",
      price: "Personalizzato",
      type: "Prezzo su richiesta",
      features: ["Configurazione personalizzata", "Integrazione API dedicata", "Supporto tecnico 24/7", "Modelli AI personalizzati", "Soluzione white-label", "Formazione personalizzata"],
      cta: "Disponibile presto",
      isComing: true
    }
  ],

  faqTitle: "Domande Frequenti",
  faqSubtitle: "Tutte le risposte alle domande più comuni sul nostro servizio",
  faqItems: [
    { question: "Come posso iniziare a usare Candy Bot?", answer: "Clicca semplicemente su 'Inizia la Prova Gratuita' e segui il processo di registrazione." },
    { question: "E se non conosco nulla di trading?", answer: "Candy Bot è progettato per tutti i livelli. I principianti possono usare le modalità automatizzate mentre i trader avanzati possono personalizzare le strategie." },
    { question: "Qual è il rendimento medio mensile?", answer: "I dati storici mostrano un rendimento medio mensile del 7-12%, anche se le performance passate non garantiscono risultati futuri." },
    { question: "A chi sono adatti i Bot?", answer: "Ideale per professionisti occupati, principianti e chiunque voglia automatizzare la propria strategia di trading." },
    { question: "Posso usare più bot contemporaneamente?", answer: "Sì! Puoi eseguire più bot con strategie diverse contemporaneamente." }
  ],

  legalTitle: "Legale & Supporto",
  legalLinks: ["Termini", "Privacy"],
  supportEmail: "support@therealworld.net",
  supportChat: "Risposta generalmente in pochi minuti",

  copyright: "© 2024-2025 Sweet Trading Inc. Tutti i diritti riservati. 🍬",

  features: [
    { title: "AI Intelligente", desc: "Analizza e impara dai mercati in tempo reale." },
    { title: "Performance Costante", desc: "Ottimizzato per ridurre errori e massimizzare i profitti." },
    { title: "Velocità Fulminea", desc: "Agisce in millisecondi alla rilevazione di pattern chiave." },
    { title: "Community Attiva", desc: "Supporto continuo e strategie condivise." }
  ],

  sectionTitles: {
    process: "Processo in 3 Passi",
    features: "Caratteristiche Chiave",
    numbers: "In Numeri",
    offer: "Offerta Speciale",
    compare: "Confronta Piani",
    faq: "FAQ",
    support: "Supporto",
    bots: "Bots",
    howItWorks: "Come Funziona"
  },

  planDetails: {
    freeTrial: "Prova GRATUITA 24h",
    includes: "Include:",
    mostPopular: "PIÙ POPOLARE",
    bestValue: "MIGLIOR RAPPORTO QUALITÀ-PREZZO"
  },

  ctaSection: {
    title: "Pronto a Trasformare il Tuo Trading?",
    subtitle: "Unisciti a migliaia di trader soddisfatti oggi stesso",
    button: "Inizia la Prova Gratuita"
  },

  buttons: {
    backToTop: "Torna su",
    contactSupport: "Contatta il supporto",
    downloadApp: "Scarica l'app",
    login: "Login"
  },

  legal: {
    riskWarning: "AVVISO DI RISCHIO: Il trading comporta rischi elevati e potrebbe non essere adatto a tutti gli investitori.",
    performanceDisclaimer: "Le performance passate non indicano risultati futuri."
  },

  languages: {
    english: "Inglese",
    italian: "Italiano",
    german: "Tedesco"
  }
};
